module.exports = __webpack_public_path__ + "img/infographics_6.b3cfb3fa.png";